import Keycloak from "./keycloak-js/lib/keycloak";
const { REACT_APP_LOGIN_URL } = process.env;

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: REACT_APP_LOGIN_URL || '',
  realm: "ctm",
  clientId: "extranet-react-client",
});

export default keycloak;
